import axios from "axios";
import { ADMIN_PORTAL_AUTH_TOKEN, ADMIN_PORTAL_API_BASE_URL } from "../utils/config";

export const deleteUrl = async (url, activeTab) => {
    let data = {
        "url": url,
        source: activeTab === "ABCD App" ? "abcd" : "service"
    }
    let config = {
        method: "post",
        url: `${ADMIN_PORTAL_API_BASE_URL}/delete_url`,
        data: data,
        headers: {
            Authorization: "Bearer " + ADMIN_PORTAL_AUTH_TOKEN
        }
    };
    try {
        const response = await axios(config);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}